import { ReactNode } from "react";

export enum ShowIn {
  "test" = "test",
  "production" = "production",
  "stage" = "stage",
}

interface EnvironmentIndicatorProps {
  showIn?: ShowIn;
  hideIn?: ShowIn;
  children: ReactNode;
}

const EnvironmentIndicator: React.FC<EnvironmentIndicatorProps> = ({
  showIn,
  children,
  hideIn,
}: {
  showIn?: ShowIn;
  hideIn?: ShowIn;
  children: ReactNode;
}) => {
  const env = process.env.REACT_APP_ENV as ShowIn;
  if (hideIn && env === hideIn) return null;
  if (!showIn) return <>{children}</>;
  return <>{env === showIn && children}</>;
};

export default EnvironmentIndicator;
